// Theme: cosmic
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'cosmic',
  name: 'COSMIC',
  tagline: 'COSMIC',
  description: 'Violeta cosmico profundo com vinheta e estrelas flutuantes.',
  category: 'cosmic-scale',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#08060F', '#7C3AED', '#10101F', '#EDE9FE'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 10%, transparent)'
    },
    shellClasses: 'font-sans theme-cosmic'
  },
  colorVars: {
    '--accent': '#7C3AED',
    '--accent-foreground': '#08060F',
    '--background': '#08060F',
    '--border': '#2A1A5A',
    '--card': '#10101F',
    '--card-border-active': 'rgba(124, 58, 237, 0.48)',
    '--card-completed': '#10101F',
    '--card-foreground': '#EDE9FE',
    '--card-glow': 'rgba(124, 58, 237, 0.1)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#08060F',
    '--foreground': '#EDE9FE',
    '--hold-fill': '#7C3AED',
    '--input': '#10101F',
    '--modal-bg': '#08060F',
    '--modal-border': '#2A1A5A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#2A1A5A',
    '--muted-foreground': '#EDE9FE',
    '--nav-active': '#7C3AED',
    '--nav-bg': '#08060F',
    '--popover': '#10101F',
    '--popover-foreground': '#EDE9FE',
    '--primary': '#7C3AED',
    '--primary-foreground': '#08060F',
    '--ring': '#7C3AED',
    '--secondary': '#2A1A5A',
    '--secondary-foreground': '#EDE9FE',
    '--streak': '#7C3AED',
    '--success': '#22C55E',
    '--success-foreground': '#08060F',
    '--xp': '#7C3AED',
    '--xp-bg': '#10101F'
  },
  resolvedVars: {
    '--accent': '#7C3AED',
    '--accent-foreground': '#08060F',
    '--accent-foreground-hsl': '253 43% 4%',
    '--accent-foreground-oklch': 'from #08060F l c h',
    '--accent-hsl': '262 83% 58%',
    '--accent-oklch': 'from #7C3AED l c h',
    '--background': '#08060F',
    '--background-hsl': '253 43% 4%',
    '--background-oklch': 'from #08060F l c h',
    '--border': '#2A1A5A',
    '--border-hsl': '255 55% 23%',
    '--border-oklch': 'from #2A1A5A l c h',
    '--border-w': '1px',
    '--card': '#10101F',
    '--card-border-active': 'rgba(124, 58, 237, 0.48)',
    '--card-completed': '#10101F',
    '--card-completed-hsl': '240 32% 9%',
    '--card-completed-oklch': 'from #10101F l c h',
    '--card-foreground': '#EDE9FE',
    '--card-foreground-hsl': '251 91% 95%',
    '--card-foreground-oklch': 'from #EDE9FE l c h',
    '--card-glow': 'rgba(124, 58, 237, 0.1)',
    '--card-hsl': '240 32% 9%',
    '--card-oklch': 'from #10101F l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#08060F',
    '--destructive-foreground-hsl': '253 43% 4%',
    '--destructive-foreground-oklch': 'from #08060F l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #EF4444 l c h',
    '--foreground': '#EDE9FE',
    '--foreground-hsl': '251 91% 95%',
    '--foreground-oklch': 'from #EDE9FE l c h',
    '--hold-fill': '#7C3AED',
    '--hold-fill-hsl': '262 83% 58%',
    '--hold-fill-oklch': 'from #7C3AED l c h',
    '--input': '#10101F',
    '--input-hsl': '240 32% 9%',
    '--input-oklch': 'from #10101F l c h',
    '--modal-bg': '#08060F',
    '--modal-bg-hsl': '253 43% 4%',
    '--modal-bg-oklch': 'from #08060F l c h',
    '--modal-border': '#2A1A5A',
    '--modal-border-hsl': '255 55% 23%',
    '--modal-border-oklch': 'from #2A1A5A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#2A1A5A',
    '--muted-foreground': '#EDE9FE',
    '--muted-foreground-hsl': '251 91% 95%',
    '--muted-foreground-oklch': 'from #EDE9FE l c h',
    '--muted-hsl': '255 55% 23%',
    '--muted-oklch': 'from #2A1A5A l c h',
    '--nav-active': '#7C3AED',
    '--nav-active-hsl': '262 83% 58%',
    '--nav-active-oklch': 'from #7C3AED l c h',
    '--nav-bg': '#08060F',
    '--nav-bg-hsl': '253 43% 4%',
    '--nav-bg-oklch': 'from #08060F l c h',
    '--popover': '#10101F',
    '--popover-foreground': '#EDE9FE',
    '--popover-foreground-hsl': '251 91% 95%',
    '--popover-foreground-oklch': 'from #EDE9FE l c h',
    '--popover-hsl': '240 32% 9%',
    '--popover-oklch': 'from #10101F l c h',
    '--primary': '#7C3AED',
    '--primary-foreground': '#08060F',
    '--primary-foreground-hsl': '253 43% 4%',
    '--primary-foreground-oklch': 'from #08060F l c h',
    '--primary-hsl': '262 83% 58%',
    '--primary-oklch': 'from #7C3AED l c h',
    '--radius': '12px',
    '--ring': '#7C3AED',
    '--ring-hsl': '262 83% 58%',
    '--ring-oklch': 'from #7C3AED l c h',
    '--secondary': '#2A1A5A',
    '--secondary-foreground': '#EDE9FE',
    '--secondary-foreground-hsl': '251 91% 95%',
    '--secondary-foreground-oklch': 'from #EDE9FE l c h',
    '--secondary-hsl': '255 55% 23%',
    '--secondary-oklch': 'from #2A1A5A l c h',
    '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 10%, transparent)',
    '--streak': '#7C3AED',
    '--streak-hsl': '262 83% 58%',
    '--streak-oklch': 'from #7C3AED l c h',
    '--success': '#22C55E',
    '--success-foreground': '#08060F',
    '--success-foreground-hsl': '253 43% 4%',
    '--success-foreground-oklch': 'from #08060F l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22C55E l c h',
    '--tint-primary-subtle': 'hsla(262 83% 58% / 0.15)',
    '--xp': '#7C3AED',
    '--xp-bg': '#10101F',
    '--xp-bg-hsl': '240 32% 9%',
    '--xp-bg-oklch': 'from #10101F l c h',
    '--xp-hsl': '262 83% 58%',
    '--xp-oklch': 'from #7C3AED l c h'
  }
}
